import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToolStationVisibleProvider } from './contexts/ToolStationVisibleContext';
import { Router } from './router';

export function App() {
  return (
    <ThemeProvider>
      <ToolStationVisibleProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </ToolStationVisibleProvider>
    </ThemeProvider>
  );
}
